// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-collapse-item__header {\n  font-weight: 700 !important;\n  height: auto !important;\n  line-height: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
